export function normalizeAnalysis(value) {
  if (value?.kind !== 'ai-generated' || typeof value.summary !== 'string' || !value.summary.trim() ||
    typeof value.limitations !== 'string' || !value.limitations.trim() ||
    !Number.isFinite(value.generatedAt) || !Number.isFinite(value.sourceReceivedAt) ||
    !Number.isFinite(new Date(value.generatedAt).getTime()) || !Number.isFinite(new Date(value.sourceReceivedAt).getTime())) return null;
  return {
    summary: value.summary.slice(0, 4000), limitations: value.limitations.slice(0, 2000),
    generatedAt: value.generatedAt, sourceReceivedAt: value.sourceReceivedAt,
    model: typeof value.model === 'string' ? value.model.slice(0, 100) : '',
    sampleCount: Number.isInteger(value.sampleCount) && value.sampleCount > 0 ? value.sampleCount : null,
    stale: value.stale === true,
  };
}

// Independent of telemetry samples: never append AI text to measurements or exports.
export function pollAnalysis(endpoint, onChange, { fetcher = fetch, intervalMs = 15000 } = {}) {
  let stopped = false, timer;
  const controller = new AbortController();
  async function refresh() {
    try {
      const response = await fetcher(endpoint, { cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Analysis unavailable');
      const event = await response.json();
      if (!stopped) onChange(normalizeAnalysis(event.analysis));
    } catch {
      if (!stopped) onChange(null);
    } finally {
      if (!stopped) timer = setTimeout(refresh, intervalMs);
    }
  }
  void refresh();
  return () => { stopped = true; clearTimeout(timer); controller.abort(); };
}
